<template>
	<div class="list_top_box">
        <div><slot name="leftItems"/></div>
		<div class="l_t_right">
			<slot name="items"/>
			<div v-if="useHelpBox" class="l_t_item l_add_line">
				<button class="l_help_bt" type="button" @click="toggleHelpMessage"/>
			</div>
		</div>
		<div v-if="useHelpBox" class="l_help_contetns">
			<div class="collapse" id="listHelpDrop" ref="helpContents">
				<div class="l_h_c_inner">
					<slot name="helpMessage"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ListTopBox',
	props: {
		useHelpBox: {
			type: Boolean,
			default: false,
		},
        helpCollapse: {
            type: Boolean,
            default: true,
        }
	},
	data() {
		return {
			foldable: false,
			eventIsRunning: false,
		}
	},
	methods: {
		toggleHelpMessage() {
			if(this.eventIsRunning) {
				setTimeout(() => {
					this.toggleHelpMessage();
				}, 5);
			}
			else {
				this.eventIsRunning = true;

				this.foldable = !this.foldable;
				if(this.foldable) {
					this.$refs.helpContents.classList.add('collapsing');
					setTimeout(() => {
						this.$refs.helpContents.style.height = '';
						setTimeout(() => {
							this.$refs.helpContents.classList.remove('collapsing');
							this.$refs.helpContents.classList.add('collapse');
							this.eventIsRunning = false;
						}, 350);
					}, 100)
				}else {
					this.$refs.helpContents.classList.remove('collapse');
					this.$refs.helpContents.classList.add('collapsing');
					setTimeout(() => {
						this.$refs.helpContents.style.height = this.$refs.helpContents.scrollHeight + 'px';
						setTimeout(() => {
							this.$refs.helpContents.classList.remove('collapsing');
							this.eventIsRunning = false;
						}, 350);
					}, 100)
				}
			}
		},
	},
    mounted() {
        if(!this.helpCollapse){
            this.foldable = false;
            this.$refs.helpContents.classList.remove('collapse');
        }
    }
}
</script>